import { BILLING_CYCLE_NAME, IBooking } from "../../../../reducers/bookings/types";
import { isLongTermBooking } from "../../../utils";
import { DateTime as d } from "luxon"

export const getBookingDuration = (booking: IBooking) => {
  const longTermBooking = isLongTermBooking(booking);

  if (longTermBooking) {
    switch (booking.rateTypeName) {
      case BILLING_CYCLE_NAME.WEEKLY:
        return booking.isRecurringBilling && booking.billingFrequency
          ? 7 * booking.billingFrequency
          : 7;

      case BILLING_CYCLE_NAME.MONTHLY:
        if (booking.isRecurringBilling && booking.billingFrequency) {
          const idealEnd = d
            .fromISO(booking.pickupDateTime || "")
            .plus({ months: booking.billingFrequency })
            .toUTC()
            .toISO();

          return d
            .fromISO(idealEnd)
            .diff(d.fromISO(booking.pickupDateTime), "day").days;
        }
        return 30;

      default:
        return 0;
    }
  }

  return Math.ceil(
    d
      .fromISO(booking.dropoffDateTime || "")
      .diff(d.fromISO(booking.pickupDateTime || ""), "days").days,
  );
};

export const getProratedFraction = (booking: IBooking) => {
  const pd = booking.paymentDetails;

  if (pd?.isProrated && pd.proratedBillingDays && pd.standardBillingDays) {
    return pd.proratedBillingDays / pd.standardBillingDays;
  }

  return 1;
};

export const getAddonBreakdown = (
  addon: any,
  isTaxExempted: boolean,
  fraction: number,
  rentalTime: number,
) => {
  if (addon.isSubscriptionIncluded) return null;

  let base = addon.rate * addon.quantity;

  if (!addon.hasFixedRate && rentalTime) {
    base = base * rentalTime;
  }

  let tax = 0;

  if (!isTaxExempted && addon.tax?.value) {
    tax = Math.round((addon.rate * addon.tax.value) / 100) * addon.quantity;

    if (!addon.hasFixedRate) {
      tax = Math.round(tax * rentalTime);
    }
  }

  const proratedBase = addon.hasFixedRate ? base : Math.round(base * fraction);

  const proratedTax = addon.hasFixedRate ? tax : Math.round(tax * fraction);

  return {
    name: addon.displayName || addon.name,
    quantity: addon.quantity,
    rate: addon.rate,
    hasFixedRate: addon.hasFixedRate,
    base,
    tax,
    total: base + tax,
    proratedBase,
    proratedTax,
    proratedTotal: proratedBase + proratedTax,
    taxLabel: addon.tax?.title
      ? `${addon.tax.title} ${addon.tax.value}%`
      : null,
  };
};
